import { render, staticRenderFns } from "./TheCategoryCheckbox.vue?vue&type=template&id=a969c720&"
import script from "./TheCategoryCheckbox.vue?vue&type=script&lang=js&"
export * from "./TheCategoryCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TheCategoryCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports